import { render } from "./InspectorManagement.vue?vue&type=template&id=43d00f00&scoped=true"
import script from "./InspectorManagement.vue?vue&type=script&lang=js"
export * from "./InspectorManagement.vue?vue&type=script&lang=js"

import "./InspectorManagement.vue?vue&type=style&index=0&id=43d00f00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d00f00"]])

export default __exports__